import { render, staticRenderFns } from "./deduct_score.vue?vue&type=template&id=b6c84fea&scoped=true&"
import script from "./deduct_score.vue?vue&type=script&lang=js&"
export * from "./deduct_score.vue?vue&type=script&lang=js&"
import style0 from "./deduct_score.vue?vue&type=style&index=0&id=b6c84fea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c84fea",
  null
  
)

export default component.exports